import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "border rounded-lg border-neutral-100" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "flex items-center justify-between p-6 border-b tabs border-neutral-100" }
const _hoisted_4 = { class: "flex items-center space-x-4" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col p-4 border-b md:items-center md:justify-between border-neutral-100 md:flex-row"
}
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = {
  type: "submit",
  class: "mr-3 border-0"
}
const _hoisted_8 = { class: "mt-6 md:mt-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-medium text-neutral-600" }, "Showing:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-semibold" }, "All Records", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "space-y-5" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "grid grid-cols-1 gap-4 p-4 lg:grid-cols-3 md:grid-cols-2 md:p-6"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "mt-6 md:mt-0" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-medium text-neutral-600" }, "Showing:", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-semibold" }, "All Records", -1)
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "space-y-5" }
const _hoisted_21 = { class: "w-full px-6 border-t py-7" }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { class: "w-full px-6 border-t py-7" }

import { onMounted, ref, watch, computed } from "vue";
import { onIonViewWillEnter } from '@ionic/vue';

import DataTable from "@/components/partials/DataTable.vue";
import MinifyPagination from "@/components/partials/MinifyPagination.vue";
import FilterPanel from "@/components/partials/FilterPanel.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import MultiSelect from "@/components/inputs/MultiSelect.vue";

import TabComponent from "@/components/partials/TabComponent.vue";
import InterventionCard from "@/components/cards/InterventionCard.vue";
import { useRouter, useRoute } from "vue-router";
import { InterventionItems } from "@/interfaces/Cases/Interevention";
import throttle from "lodash/throttle";
import debounce from "lodash/debounce";
import pickBy from "lodash/pickBy";
import PageLoader from "@/components/loaders/PageLoader.vue";
import { useNetworkStore } from '@/store/network';
import InteventionTable from "./Tables/InteventionTable.vue";
import ActivityLogsTable from "@/views/activity-logs/ActivityLogsTable.vue"
import SimplePagination from "@/components/partials/SimplePagination.vue";
import InterventionService from "@/classes/Interventions/InterventionService";
import SearchTwoIcon from "@/components/icons/searchTwoIcon.vue";
import ListIcon from "@/components/icons/listIcon.vue";
import CardIcon from "@/components/icons/cardIcon.vue";
import OnlineSynching from "@/classes/Synching/OnlineSynching";


export default /*#__PURE__*/_defineComponent({
  __name: 'InterventionViewPage',
  emits: ['update:patientName', 'update:interventionType'],
  setup(__props, { emit: __emit }) {

const showFilter = ref<boolean>(false);
const displayMode = ref<boolean>(false);

const route = useRoute();
const router = useRouter();
const patient = ref<string | null>('');
const patientId = ref<number | null>(route.params.patient);
const caseId = ref<number | null>(route.params.case);
const items = ref<InterventionItems[]>([]);
const lastPage = ref<number | null>(null);
const loading = ref<boolean>(false);
const interventionOption = ref<Array<any>>([]);
const legendOption = ref<Array<any>>([]);
const onlineSync = new OnlineSynching();

const filters = ref<{
	scheduleDate: Array<any>
	doneOnDate: Array<any>
	query: string
	page :number
	rows :number
	tab :string|null
	intervention_type : number|null
	legend : number|null
    case_number: string | null,
}>({
	scheduleDate: [],
	doneOnDate: [],
	query: route.query.query,
	page: 1,
	rows: 20,
	tab: route.query.tab || '',
	intervention_type: null,
	legend: null,
    case_number: null,
})

const numRows = computed<string | null>(() => (filters.value.rows ? filters.value.rows + " Rows" : "All"));

const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);
const offlineParams = ref<string>(route.query.offline);
const caseNumbers = ref<[]>([]);

const tabs = ref<{ name: string; count: number; tab: string; href: string; allowed: boolean }[]>([
	{
		name: "All",
		count: 0,
		tab: "",
		href: caseId.value
			? `/patient/${patientId.value}/cases/${caseId.value}/interventions`
			: `/intervention/${patientId.value}/view`,
		allowed: true,
	},
	{
		name: "Archived",
		count: 0,
		tab: "archived",
		href: caseId.value
			? `/patient/${patientId.value}/cases/${caseId.value}/interventions?tab=archived`
			: `/intervention/${patientId.value}/view?tab=archived`,
		allowed: true,
	},
	{
		name: "Activity logs",
		count: 0,
		tab: "activity_logs",
		href: caseId.value
			? `/patient/${patientId.value}/cases/${caseId.value}/interventions?tab=activity_logs`
			: `/intervention/${patientId.value}/view?tab=activity_logs`,
		allowed: true,
	},
]);

const headers: { text: string; haveSort?: boolean }[] = [
	{ text: "Schedule Date/Time", haveSort: true },
	{ text: "Intervention" },
	{ text: "Type" },
	{ text: "Sub-type" },
	{ text: "Case Number" },
	{ text: "To Be Done By" },
	{ text: "Done On" },
	{ text: "Status" },
];

const emit = __emit;

const getData = (search: any = null): void => {
	loading.value = true;
	InterventionService.index(
		patientId.value,
		caseId.value,
		filters.value,
		isNetworkAvailable.value
	)
		.then(async ({data}) => {
			emit('update:patientName', data.patient); 
			emit('update:interventionType', data.interventionType); 
			
			patient.value = data.patient;
			interventionOption.value = data.interventionType;
			legendOption.value = data.legends;
			filters.value.page = data.items.current_page;
			lastPage.value = data.items.last_page;
            caseNumbers.value = data.caseNumbers;
			
			tabs.value[0].count = data.allItemsCount;
			tabs.value[1].count = data.archivedItemsCount;
			tabs.value[2].count = data.activityLogsCount;

			
			if(filters.value.tab == 'activity_logs'){
				items.value = data.items;
			} else {
				items.value = data.items.data;

				await storePatientInterventionsForOffline(items.value);
			}

			loading.value = false;
		})
		.catch((error) => {
			console.log(error);
			loading.value = false;
		});
};

const storePatientInterventionsForOffline = async (items: any): Promise<void> => {
	if(items.length > 0 && isNetworkAvailable.value) {
		await InterventionService.storeOffline(items)
	}
};

const reloadPage = async () => {
	return await router.push({
		path: caseId.value
			? `/patient/${patientId.value}/cases/${caseId.value}/interventions`
			: `/intervention/${patientId.value}/view`,
		query: pickBy(filters.value),
	});
};

const applyFilters = () => {
	reloadPage().then(() => {
		showFilter.value = false
		getData();
	});
};

const applyReset = () => {
	filters.value = {
		scheduleDate: [],
		doneOnDate: [],
		query: '',
		page: 1,
		rows: 20,
		tab: '',
		intervention_type: null,
		legend: null
	}
	
	reloadPage().then(() => {
		getData();
		showFilter.value = false;
	});
};

const paginate = (data: number|object): void => {
	if(filters.value.tab == 'activity_logs'){

		filters.value = Object.assign(filters.value, data)
	} else {
		filters.value.page = data;
	}
	applyFilters();
};

const changeRows = (row: any): void => {
	filters.value.rows = row;
	applyFilters();
};

const updateTab = (currentTab: string) => {
	filters.value.tab = currentTab;
	filters.value.page = 1;
	applyFilters();
};

/**
 * WATCHERS
 */
watch(
	() => filters.value.query,
	debounce((val: string) => {
		reloadPage().then(() => {
            filters.value.page = 1;
			getData(val);
		});
	}, 1000)
);

watch(
	() => isNetworkAvailable.value,
	async (val) => {
        loading.value = false;
		await getData();
        await onlineSync.checkDrafts();
	}
);

onMounted(() => getData() );
onIonViewWillEnter(async () => {
    await getData();
    await onlineSync.checkDrafts();
} );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (displayMode.value = false)),
            class: _normalizeClass(["flex items-center px-4 py-2 border-b border-l border-r border-solid border-neutral-100 group/mode", !displayMode.value ? 'bg-primary-300' : ''])
          }, [
            _createVNode(ListIcon, {
              class: _normalizeClass(["w-6 h-6 object-contain grayscale brightness-[0.3]", !displayMode.value ? '' : 'grayscale brightness-[1.5] group-hover/mode:grayscale-0 group-hover/mode:brightness-100'])
            }, null, 8, ["class"]),
            _createElementVNode("span", {
              class: _normalizeClass(["ml-2 text-xs font-bold transition md:text-base", !displayMode.value ? 'text-primary-600' : 'text-gray-600 group-hover/mode:text-primary-600'])
            }, "List View", 2)
          ], 2),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (displayMode.value = true)),
            class: _normalizeClass(["flex items-center px-4 py-2 border-b border-r border-solid border-neutral-100 group/mode", displayMode.value ? 'bg-primary-300' : ''])
          }, [
            _createVNode(CardIcon, {
              class: _normalizeClass(["w-6 h-6 object-contain", displayMode.value ? '' : 'grayscale brightness-[1.5] group-hover/mode:grayscale-0 group-hover/mode:brightness-100'])
            }, null, 8, ["class"]),
            _createElementVNode("span", {
              class: _normalizeClass(["ml-2 text-xs font-bold transition md:text-base", displayMode.value ? 'text-primary-600' : 'text-gray-600 group-hover/mode:text-primary-600'])
            }, "Board View", 2)
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(TabComponent, {
              tabs: tabs.value,
              "onUpdate:tab": _cache[2] || (_cache[2] = (value) => updateTab(value))
            }, null, 8, ["tabs"])
          ])
        ]),
        (displayMode.value && filters.value.tab != 'activity_logs')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", _hoisted_7, [
                  _createVNode(SearchTwoIcon, { class: "w-5 h-5 object-contain grayscale brightness-[0.3]" })
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.value.query) = $event)),
                  type: "text",
                  name: "search",
                  id: "search",
                  placeholder: "Search to be done by",
                  class: "p-0 text-neutral-600 placeholder:font-medium placeholder-neutral-400 border-0 focus:ring-0 focus:outline-none min-w-[300px]"
                }, null, 512), [
                  [_vModelText, filters.value.query]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  type: "button",
                  class: "flex items-center px-3 py-2 space-x-1 transition border border-solid rounded border-neutral-100 w-max hover:bg-primary-100",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (showFilter.value = true))
                }, _hoisted_11),
                _createVNode(FilterPanel, {
                  show: showFilter.value,
                  onCancel: _cache[10] || (_cache[10] = ($event: any) => (showFilter.value = false)),
                  onClose: _cache[11] || (_cache[11] = ($event: any) => (showFilter.value = false)),
                  "onApply:reset": _cache[12] || (_cache[12] = ($event: any) => (applyReset())),
                  "onApply:filters": _cache[13] || (_cache[13] = ($event: any) => (applyFilters()))
                }, {
                  fields: _withCtx(() => [
                    _createElementVNode("div", _hoisted_12, [
                      _createTextVNode("` "),
                      _createVNode(DatePicker, {
                        id: "schedule_date",
                        name: "schedule_date",
                        label: "Schedule Date",
                        modelValue: filters.value.scheduleDate,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.value.scheduleDate) = $event)),
                        class: "filter-range",
                        range: "",
                        multiCalendars: ""
                      }, null, 8, ["modelValue"]),
                      _createVNode(DatePicker, {
                        id: "done_on_date",
                        name: "done_on_date",
                        label: "Done On Date",
                        class: "filter-range",
                        modelValue: filters.value.doneOnDate,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.value.doneOnDate) = $event)),
                        range: "",
                        multiCalendars: ""
                      }, null, 8, ["modelValue"]),
                      _createVNode(MultiSelect, {
                        options: interventionOption.value,
                        label: "Intervention",
                        id: "intervention",
                        name: "intervention",
                        placeholder: "Select..",
                        modelValue: filters.value.intervention_type,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filters.value.intervention_type) = $event)),
                        searchable: ""
                      }, null, 8, ["options", "modelValue"]),
                      _createVNode(MultiSelect, {
                        options: legendOption.value,
                        label: "Legend",
                        id: "legend",
                        name: "legend",
                        placeholder: "Select..",
                        modelValue: filters.value.legend,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filters.value.legend) = $event)),
                        searchable: ""
                      }, null, 8, ["options", "modelValue"]),
                      _createVNode(MultiSelect, {
                        options: caseNumbers.value,
                        label: "Case Number",
                        id: "select_case_number",
                        name: "select_case_number",
                        placeholder: "Select...",
                        modelValue: filters.value.case_number,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((filters.value.case_number) = $event)),
                        searchable: ""
                      }, null, 8, ["options", "modelValue"])
                    ])
                  ]),
                  _: 1
                }, 8, ["show"])
              ])
            ]))
          : _createCommentVNode("", true),
        (filters.value.tab != 'activity_logs')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (displayMode.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
                      return (_openBlock(), _createBlock(InterventionCard, {
                        key: item,
                        item: item,
                        interventionType: item.intervention_type_name,
                        intervention: item.intervention_type_name,
                        status: item.status,
                        caseNumber: item.case_number,
                        doneBy: item.done_by,
                        doneOn: item.done_on,
                        "onUpdate:refresh": _cache[14] || (_cache[14] = ($event: any) => (getData()))
                      }, null, 8, ["item", "interventionType", "intervention", "status", "caseNumber", "doneBy", "doneOn"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (!displayMode.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createVNode(DataTable, {
                      headers: headers,
                      "no-action": false,
                      count: items.value.length,
                      hasSearch: true,
                      searchPlaceholder: "Search to be done by",
                      tableClass: "header-frm-table",
                      dataTableClass: "border-0",
                      search: filters.value.query,
                      "onUpdate:searchText": _cache[29] || (_cache[29] = (value) => (filters.value.query = value)),
                      parentTableClass: "overflow-auto"
                    }, {
                      topContent: _withCtx(() => [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "flex items-center px-3 py-2 space-x-1 transition border border-solid rounded border-neutral-100 hover:bg-primary-100 w-max",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (showFilter.value = true))
                          }, _hoisted_19),
                          _createVNode(FilterPanel, {
                            show: showFilter.value,
                            "onApply:reset": _cache[23] || (_cache[23] = ($event: any) => (applyReset())),
                            "onApply:filters": _cache[24] || (_cache[24] = ($event: any) => (applyFilters())),
                            onClose: _cache[25] || (_cache[25] = ($event: any) => (showFilter.value = false)),
                            onCancel: _cache[26] || (_cache[26] = ($event: any) => (showFilter.value = false)),
                            onConfirm: _cache[27] || (_cache[27] = ($event: any) => (showFilter.value = false)),
                            customClass: "!overflow-visible overflow-x-visible"
                          }, {
                            fields: _withCtx(() => [
                              _createElementVNode("div", _hoisted_20, [
                                _createVNode(DatePicker, {
                                  id: "schedule_date",
                                  name: "schedule_date",
                                  label: "Schedule Date",
                                  class: "filter-range",
                                  range: "",
                                  multiCalendars: "",
                                  modelValue: filters.value.scheduleDate,
                                  "onUpdate:modelValue": [
                                    _cache[16] || (_cache[16] = ($event: any) => ((filters.value.scheduleDate) = $event)),
                                    _cache[17] || (_cache[17] = (value) => (filters.value.scheduleDate = value))
                                  ]
                                }, null, 8, ["modelValue"]),
                                _createVNode(DatePicker, {
                                  id: "done_on_date",
                                  name: "done_on_date",
                                  label: "Done On Date",
                                  class: "filter-range",
                                  range: "",
                                  multiCalendars: "",
                                  modelValue: filters.value.doneOnDate,
                                  "onUpdate:modelValue": [
                                    _cache[18] || (_cache[18] = ($event: any) => ((filters.value.doneOnDate) = $event)),
                                    _cache[19] || (_cache[19] = (value) => (filters.value.doneOnDate = value))
                                  ]
                                }, null, 8, ["modelValue"]),
                                _createVNode(MultiSelect, {
                                  options: interventionOption.value,
                                  label: "Intervention",
                                  id: "intervention",
                                  name: "intervention",
                                  placeholder: "Select..",
                                  modelValue: filters.value.intervention_type,
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((filters.value.intervention_type) = $event)),
                                  searchable: ""
                                }, null, 8, ["options", "modelValue"]),
                                _createVNode(MultiSelect, {
                                  options: legendOption.value,
                                  label: "Legend",
                                  id: "legend",
                                  name: "legend",
                                  placeholder: "Select..",
                                  modelValue: filters.value.legend,
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((filters.value.legend) = $event)),
                                  searchable: ""
                                }, null, 8, ["options", "modelValue"]),
                                _createVNode(MultiSelect, {
                                  options: caseNumbers.value,
                                  label: "Case Number",
                                  id: "select_case_number",
                                  name: "select_case_number",
                                  placeholder: "Select...",
                                  modelValue: filters.value.case_number,
                                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((filters.value.case_number) = $event)),
                                  searchable: ""
                                }, null, 8, ["options", "modelValue"])
                              ])
                            ]),
                            _: 1
                          }, 8, ["show"])
                        ])
                      ]),
                      body: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
                          return (_openBlock(), _createBlock(InteventionTable, {
                            key: item,
                            item: item,
                            status: item.status,
                            interventionType: item.intervention_type_name,
                            caseNumber: item.case_number,
                            doneBy: item.done_by,
                            doneOn: item.done_on,
                            "onUpdate:refresh": _cache[28] || (_cache[28] = ($event: any) => (getData()))
                          }, null, 8, ["item", "status", "interventionType", "caseNumber", "doneBy", "doneOn"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["count", "search"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(MinifyPagination, {
                  numRows: numRows.value,
                  "onUpdate:rows": _cache[30] || (_cache[30] = (value) => changeRows(value)),
                  "onUpdate:page": _cache[31] || (_cache[31] = (value) => paginate(value)),
                  "current-page": filters.value.page,
                  "last-page": lastPage.value
                }, null, 8, ["numRows", "current-page", "last-page"])
              ])
            ]))
          : _createCommentVNode("", true),
        (filters.value.tab == 'activity_logs')
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createVNode(ActivityLogsTable, { items: items.value }, null, 8, ["items"]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(SimplePagination, {
                  numRows: filters.value.rows,
                  currentPage: items.value.current_page,
                  "last-page": items.value.last_page,
                  onUpdate: _cache[32] || (_cache[32] = (value) => paginate(value))
                }, null, 8, ["numRows", "currentPage", "last-page"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
  ], 64))
}
}

})